import { render, staticRenderFns } from "./BuyDeviceProductDetails.vue?vue&type=template&id=59edcef2&"
import script from "../js/buyproductdetaildescription.js?vue&type=script&lang=js&"
export * from "../js/buyproductdetaildescription.js?vue&type=script&lang=js&"
import style0 from "../css/buy-device-product-details.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports